import * as types from "./types";

export const actionCreators = {
    OpenDialog: (obj) => (dispatch, getState) => {
        return dispatch({ type: types.OPEN_ALERTDIALOG, payload: obj });
    },
    CloseDialog: () => (dispatch, getState) => {
        return dispatch({ type: types.CLOSE_ALERTDIALOG });
    },
    ClearDialog: () => (dispatch, getState) => {
        return dispatch({ type: types.CLEAR_DIALOG });
    }
};
